import React, { useState } from "react";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import { fontSize, margins } from "style";
import { useAuth } from "hooks";
import { UPDATE_USER } from "graphql/mutations";
import { GET_ME } from "graphql/queries";
import Card from "components/Card";
import { Header } from "components/DisplayBox";
import { Link } from "components/Links";
import { EmailChangeModal } from "components/Profile";
import { H3 } from "components/Text";
import AccountValue from "./AccountValue";

/**
 * AccountEmail
 *
 * Shows the signed-in user's email and lets them request a change, which applies once confirmed.
 */
const AccountEmail = () => {
  const { id, email, unconfirmedEmail } = useAuth();
  const [showModal, setShowModal] = useState(false);

  return (
    <Card>
      <Header noUnderline>
        <H3>
          <FormattedMessage id="UserSettings.Account.Email.Title" />
        </H3>
        <FormattedMessage id="UserSettings.Account.Email.Description" />
      </Header>

      <AccountValue onChange={() => setShowModal(true)}>{email}</AccountValue>

      {unconfirmedEmail && (
        <p role="status" css={styles.pending}>
          <FormattedMessage
            id="Profile.Setting.Form.EmailFieldDescription"
            values={{ email: <Link to={`mailto:${unconfirmedEmail}`}>{unconfirmedEmail}</Link> }}
          />
        </p>
      )}

      <EmailChangeModal
        updateId={id}
        show={showModal}
        onClose={() => setShowModal(false)}
        mutationData={{ mutationName: { update: UPDATE_USER }, refetchQueries: [GET_ME], refetchAfterMutate: true }}
        successMessageId="UserSettings.Account.Email.SaveSuccess"
      />
    </Card>
  );
};

const styles = {
  pending: css`
    margin: ${margins.xsmall} 0 0;
    font-size: ${fontSize.xsmall};
    font-style: italic;
  `,
};

export default AccountEmail;
